
// src/telemetry/TelemetryProvider.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import Telemetry from './Telemetry';

const TelemetryContext = createContext({
  tSessionId: undefined,
  track: () => {},
  telemetry: null,
});

export function TelemetryProvider({ children, claimNum, baseUrl, tokenProvider }) {
  const [telemetry, setTelemetry] = useState(null);
  const [tSessionId, setTSessionId] = useState();

  useEffect(() => {
    const t = Telemetry.init({ baseUrl, tokenProvider, flushIntervalMs: 2000 });
    setTelemetry(t);

    (async () => {
      try {
        const sid = await t.createSession(claimNum, {
          appVersion: process.env.REACT_APP_VERSION || '1.0.0',
          device: navigator.userAgent,
          tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
        setTSessionId(sid);
      } catch (e) {
        console.error('Telemetry init error:', e);
      }
    })();

    return () => t.dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl, tokenProvider, claimNum]);

  const track = useMemo(() => (type, payload) => telemetry && telemetry.track(type, payload), [telemetry]);

  return (
    <TelemetryContext.Provider value={{ tSessionId, track, telemetry }}>
      {children}
    </TelemetryContext.Provider>
  );
}

export function useTelemetry() {
  return useContext(TelemetryContext);
}
